/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_NaamInputs */

const nl_planning_vakanties_naam = /** @type {(inputs: Planning_Vakanties_NaamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

/**

* @param {Planning_Vakanties_NaamInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_naam = /** @type {((inputs?: Planning_Vakanties_NaamInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_NaamInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_naam(inputs)
});
export { planning_vakanties_naam as "planning.vakanties.naam" }